<template>
  <div class="log text-left">
    <download-csv
      class="inline-block	mb-4 bg-bimmpurple-500 hover:bg-bimmpurple-700 border-bimmpurple-500 hover:border-bimmpurple-700 text-xs font-semibold border-2 text-white py-1 px-2 rounded"
      :data="storeState.log">
      Download Data
    </download-csv>
    <table class="w-full text-left">
      <thead>
        <tr>
          <th>First</th>
          <th>Last</th>
          <th>Email</th>
          <th>Phone</th>
          <th>College</th>
          <th>Course level</th>
          <th>Discipline</th>
          <th>M</th>
        </tr>
      </thead>
      <tbody>
        <tr 
          class="border border-t-2 border-b-0 border-l-0 border-r-0 border-gray-800 first:border-t-0"
          v-for="(item, index) in this.log" 
          :key="index"
        >
          <td class="border-r-2 border-gray-800 p-2">
            {{item.firstname}}
          </td>
          <td class="border-r-2 border-gray-800 p-2">
            {{item.lastname}}
          </td>
          <td class="border-r-2 border-gray-800 p-2">
            {{item.email}}
          </td>
          <td class="border-r-2 border-gray-800 p-2">
            {{item.phonenumber}}
          </td>
          <td class="border-r-2 border-gray-800 p-2">
            {{item.college}}
          </td>
          <td class="border-r-2 border-gray-800 p-2">
            {{item.courselevel}}
          </td>
          <td class="border-r-2 border-gray-800 p-2">
            {{item.discipline}}
          </td>
          <td class="border-r-0 border-gray-800 p-2">
            {{item.marketing}} 
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import store from "@/stores/store.js";

export default {
  name: "log",
  data() {
    return {
      storeState: store.state,
      log: []
    }
  },
  mounted() {
    this.log = store.state.log ? store.state.log : [];
  }
};
</script>